import {
	ResponsiveContainer,
	ComposedChart,
	XAxis,
	YAxis,
	Bar,
	Line,
	LabelList,
	Tooltip,
	BarChart,
	Legend,
	Label,
	CartesianGrid,
} from "recharts";
import { numberFormatter } from "../../utils";
import FileDownloadIcon from "@rsuite/icons/FileDownload";
import { CSVLink } from "react-csv";
import { useRef } from "react";
import { Button } from "rsuite";

interface Props {
	chartData: Array<T>;
	spendText: any;
	approach: any;
	keyMetricsData: any;
	export2Data: any;
}

interface T {
	quarter: string;
	actual: number;
	forecastedSpend: number;
	spendNeededForNextTier: number;
	spendShift: number;
	targetGrowthSpend: number;
}

const ValueTrackerChart = (props: Props) => {
	let data = props?.chartData;
	const exportFullRef2 = useRef<any>(null);
	data?.map((item: any) => {
		if (item.Month < item.selectedMonth) {
			item.YTD1 = item.YTD;
			item.YTD2 = null;
		} else if (item.Month == item.selectedMonth) {
			item.YTD1 = item.YTD;
			item.YTD2 = item.YTD;
		} else {
			item.YTD1 = null;
			item.YTD2 = item.YTD;
		}
		if (item.Month == 1) {
			item.MonthName = "Jan";
		} else if (item.Month == 2) {
			item.MonthName = "Feb";
		} else if (item.Month == 3) {
			item.MonthName = "Mar";
		} else if (item.Month == 4) {
			item.MonthName = "Apr";
		} else if (item.Month == 5) {
			item.MonthName = "May";
		} else if (item.Month == 6) {
			item.MonthName = "Jun";
		} else if (item.Month == 7) {
			item.MonthName = "Jul";
		} else if (item.Month == 8) {
			item.MonthName = "Aug";
		} else if (item.Month == 9) {
			item.MonthName = "Sep";
		} else if (item.Month == 10) {
			item.MonthName = "Oct";
		} else if (item.Month == 11) {
			item.MonthName = "Nov";
		} else if (item.Month == 12) {
			item.MonthName = "Dec";
		}
	});

	let maxYTD = data?.reduce(
		(max: any, item: any) => (item?.YTD > max ? item?.YTD : max),
		-Infinity
	);
	let minYTD = data?.reduce(
		(min: any, item: any) => (item?.YTD < min ? item?.YTD : min),
		Infinity
	);
	let maxlastyear = data?.reduce(
		(max: any, item: any) => (item?.lastyear > max ? item?.lastyear : max),
		-Infinity
	);
	let minlastyear = data?.reduce(
		(min: any, item: any) => (item?.lastyear < min ? item?.lastyear : min),
		Infinity
	);

	maxYTD = maxYTD > maxlastyear ? maxYTD * 1.1 : maxlastyear * 1.1;
	minYTD = minYTD > minlastyear ? minlastyear * 0.9 : minYTD * 0.9;

	console.log("chart", data);

	let spendText = props?.spendText;
	const CustomLegend = ({ approach }: any) => (
		<div
			style={{
				display: "flex",
				gap: "2rem",
				alignItems: "center",
				color: "black",
				fontSize: "0.8rem",
			}}
		>
			<span>
				<span
					style={{
						display: "inline-block",
						width: 20,
						height: 10,
						background: "#0097a9",
						marginRight: 8,
						verticalAlign: "middle",
					}}
				/>
				2024 Actuals
			</span>
			<span>
				<span
					style={{
						display: "inline-block",
						width: 20,
						height: 10,
						background: "#86bc25",
						marginRight: 8,
						verticalAlign: "middle",
					}}
				/>
				2025 Actuals
			</span>
			<span>
				<span
					style={{
						display: "inline-block",
						width: 20,
						height: 10,
						background: "#499e34",
						marginRight: 8,
						borderBottom: "2px dashed #499e34",
						verticalAlign: "middle",
					}}
				/>
				{`Approach ${
					props.approach === "approach1"
						? "1"
						: props.approach === "approach2"
						? "2"
						: "3"
				}`}
			</span>
		</div>
	);

	const customTooltip = ({ active, payload, props }: any) => {
		if (active && payload && payload.length) {
			const data = payload[0].payload;

			const popupStyle = {
				width: "fit-content",
				background: "white",
				border: "1px solid #ccc",
				boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
				borderRadius: "1vh",
				color: "black",
				padding: 0,
			};

			return (
				<div style={popupStyle}>
					{/* Header Row */}
					<div className="w-full flex justify-start h-[3vh] items-center bg-[#f0f4f8] py-[3vh] px-[1vh] textSmall">
						<div className="font-bold uppercase">Month:</div>
						<div
							className="font-bold ml-1"
							style={{ color: "#3f3f3f" }}
						>
							{data.MonthName}
						</div>
					</div>

					{/* Data Rows */}
					<div className="h-fit p-[1vh] mt-[.5vh] mb-[.5vh]">
						<p
							className="label"
							style={{ padding: "0", margin: "0" }}
						>
							<label
								className="graph-label-small"
								style={{
									color: "#5a5a5a",

									fontWeight: "normal",
								}}
							>
								2024 Spend :{" "}
							</label>
							<label
								className="graph-label-small"
								style={{
									color: "#3f3f3f",

									fontWeight: "bold",
								}}
							>
								{numberFormatter(data.lastyear, 2, "$")}
							</label>
						</p>

						{data.YTD1 && (
							<p
								className="label"
								style={{ padding: "0", margin: "0" }}
							>
								<label
									className="graph-label-small"
									style={{
										color: "#5a5a5a",

										fontWeight: "normal",
									}}
								>
									2025 Spend :{" "}
								</label>
								<label
									className="graph-label-small"
									style={{
										color: "#3f3f3f",

										fontWeight: "bold",
									}}
								>
									{numberFormatter(data.YTD1, 2, "$")}
								</label>
							</p>
						)}

						{data.YTD2 && !data.YTD1 && (
							<p
								className="label"
								style={{ padding: "0", margin: "0" }}
							>
								<label
									className="graph-label-small"
									style={{
										color: "#5a5a5a",

										fontWeight: "normal",
									}}
								>
									Approach{" "}
									{`${
										props?.approach === "approach1"
											? "1"
											: props?.approach === "approach2"
											? "2"
											: "3"
									}`}{" "}
									Spend :{" "}
								</label>
								<label
									className="graph-label-small"
									style={{
										color: "#3f3f3f",

										fontWeight: "bold",
									}}
								>
									{numberFormatter(data.YTD2, 2, "$")}
								</label>
							</p>
						)}

						<p
							className="label"
							style={{ padding: "0", margin: "0" }}
						>
							<label
								className="graph-label-small"
								style={{
									color: "#5a5a5a",

									fontWeight: "normal",
								}}
							>
								Incremental Rebate :{" "}
							</label>
							<label
								className="graph-label-small"
								style={{
									color: "#3f3f3f",

									fontWeight: "bold",
								}}
							>
								{numberFormatter(
									data.cumulativeRebateDifference,
									2,
									"$"
								)}
							</label>
						</p>
					</div>
				</div>
			);
		}
		return null;
	};

	const exportDataClick2 = () => {
		if (props.export2Data?.length > 0) {
			exportFullRef2?.current?.link.click();
		}
	};

	const csvHeaders2 = [
		{ label: "Month", key: "Month" },
		{ label: "2024 Spend", key: "lastYearSpend" },
		{ label: "2025 Spend", key: "currSpend" },
	];

	return (
		<div className="supplier-chart w-full h-full border border-lightGrey shadow-md bg-white p-2">
			{/* <p className="text-center italic font-semibold text-black text-0.95vw">
				{" "}
				Spend & Incremental Rebate Trend{" "}
			</p>

			<p
				className="bg-[#4d4d4d] w-full relative top-[1vh] z-[9] h-[0] flex justify-end px-[3vh] font-semibold text-[1.8vh]"
				style={{ color: "#40a108" }}
			>
				Estimated Growth YOY :{" "}
				{props?.keyMetricsData?.currentYearSpendIncrease?.toFixed(2)}%
			</p> */}
			<div className="headSpace">
				<span className="headContent">
					{" "}
					Spend & Incremental Rebate Trend{" "}
				</span>
				<div className="flex">
					<p
						className="flex justify-end px-[2vh] font-semibold textNormal mt-[0] items-center"
						style={{
							color:
								props?.keyMetricsData
									?.currentYearSpendIncrease > 0
									? "#40a108"
									: "#a10808",
						}}
					>
						Estimated Growth YOY :{" "}
						{props?.keyMetricsData?.currentYearSpendIncrease?.toFixed(
							2
						)}
						%
					</p>
					<Button
						className="bg-transparent hover:bg-transparent"
						onClick={() => {
							exportDataClick2();
						}}
					>
						<FileDownloadIcon
							color="black"
							className="text-fsre15"
						/>
					</Button>

					<CSVLink
						ref={exportFullRef2}
						data={props.export2Data}
						headers={csvHeaders2}
						filename="spend_trend.csv"
						className="hidden"
						target="_blank"
					>
						{" "}
					</CSVLink>
				</div>
			</div>
			<ResponsiveContainer
				width="100%"
				height="80%"
				className=" p-[2vh] pt-[0]"
			>
				<ComposedChart
					data={data}
					className="chartConatiner"
					margin={{
						top: 20,
						right: 20,
						bottom: 10,
						left: 10,
					}}
				>
					<CartesianGrid
						fill="#ffffff"
						fillOpacity={1}
						stroke="none"
					/>
					<XAxis
						dataKey="MonthName"
						className="graph-label"
						stroke="black"
					>
						<Label
							value="Months"
							offset={-5}
							className="graph-label "
							position="bottom"
							style={{ fill: "black" }}
						/>
					</XAxis>
					<YAxis
						className="graph-label "
						stroke="black"
						tickFormatter={(value: number) =>
							numberFormatter(value, 0, "$")
						}
						// domain={['dataMin - 10000000', 'dataMax + 10000000']}
						domain={[minYTD, maxYTD]}
					>
						<Label
							value="Spend ($)"
							angle={-90}
							offset={1}
							className="graph-label "
							position="insideLeft"
							style={{ fill: "black", textAnchor: "middle" }}
						/>
					</YAxis>
					{/* <YAxis
              yAxisId="secondAxis"
              // hide={true}
              orientation="right"
              domain={[0, maxRebateDiff]}
              stroke="white"
              fontSize="1.5vh"
              tickFormatter={(value: number) => numberFormatter(value, 0, "$")}
            >
               <Label
                  value="Total Incremental Rebate ($)"
                  angle={-90}
                  offset={5}
                  fontSize={'1.8vh'}
                  position="insideRight"
                  style={{ fill: "white", textAnchor: "middle" }}
                />
            </YAxis> */}
					<Tooltip
						contentStyle={{
							color: "white",
							backgroundColor: "rgb(26, 25, 22)",
						}}
						cursor={{ strokeDasharray: "3 3", fill: "#212121" }}
						content={customTooltip}
					/>

					{/* <Bar
              dataKey="cumulativeRebateDifference"
              yAxisId="secondAxis"
              name={`Cumulative NIA Rebate $`}
              // legendType="none"
              stackId="a"
              fill="#18b767"
              barSize={40}
            >
              <LabelList
                dataKey="cumulativeRebateDifference"
                fill="white"
                fontWeight={700}
                fontSize="1.2vh"
                formatter={(value: number) =>
                  value == 0 ? null : numberFormatter(value, 0, "$")
                }
                position="center"
              ></LabelList>
            </Bar> */}

					<Line
						type="linear"
						dataKey="lastyear"
						name={`2024 Actuals`}
						stroke="#0097a9"
						strokeDasharray={"0"}
						connectNulls={false}
						strokeWidth={3}
					/>
					<Line
						type="linear"
						dataKey="YTD1"
						// legendType="none"
						stroke="#86bc25"
						name={`2025 Actuals`}
						strokeDasharray={"0"}
						connectNulls={true}
						strokeWidth={3}
					/>
					<Line
						type="linear"
						dataKey="YTD2"
						stroke="#499e34"
						//   legendType="none"
						name={`Approach ${
							props?.approach === "approach1"
								? "1"
								: props?.approach === "approach2"
								? "2"
								: "3"
						}`}
						strokeDasharray={"3 3"}
						connectNulls={true}
						strokeWidth={3}
					/>
				</ComposedChart>
			</ResponsiveContainer>
			<div className="contentFooter">
				<CustomLegend approach={props.approach} />
			</div>
		</div>
	);
};

export default ValueTrackerChart;
